<template>
  <div>
    <div class="header"><h1>Guide</h1></div>
    <div class="content panel">
      <h2>Embedding</h2>
      <p>There are a few way to embed your shelves into your own website.</p>
      <h3>Browseable shelf</h3>
      <p>Add ?embed to the end of any URL.
      This will disable most of the UI and features but still allow you to scroll through the books on the shelf:</p>
      <textarea><iframe src="https://shelvi.st/user/thingsinjars/shelf/non-fiction?embed"
        width="600" height="350" frameborder="0" style="width:100%;height:350px;">
  <p> <a href="https://shelvi.st/user/thingsinjars/shelf/non-fiction?embed">
    thingsinjars Non-fiction Shelf
  </a> </p>
</iframe>
</textarea>
        <iframe src="https://shelvi.st/user/thingsinjars/shelf/non-fiction?embed"
        width="600" height="350" frameborder="0" style="width:100%;height:350px;">
  <p> <a href="https://shelvi.st/user/thingsinjars/shelf/non-fiction?embed">
    thingsinjars Non-fiction Shelf
  </a> </p>
</iframe>
      <h3>First book on a shelf</h3>
      <p>Create an img tag pointing you your shelf. This will update whenever you change the first book on the shelf.</p>
      <code><pre>&lt;img src="https://shelvi.st/thumb/thingsinjars/reading.png"/&gt;</pre></code>
      <img src="https://shelvi.st/thumb/thingsinjars/reading.png"/>
    </div>
  </div>
</template>
<script>
export default {};
</script>
